@if (ticket && subscription) {
  <div>
    @if (isTicketView) {
      <div>
        <div class="mb-3">
          <button name="back" class="btn btn-outline-primary" [routerLink]="['/support']" >{{ 'app_back' | i18next }}</button>
        </div>
        <div class="d-flex flex-row align-items-center mb-3 ml-3 mr-3">
          <div class="h3">{{ ticket.title }}</div>
          @if (!isTicketClosed) {
            <div class="ml-auto bd-highlight">
              <button name="close-ticket" class="btn btn-outline-primary" (click)="closeTicket()" [disabled]="isRequesting">{{ 'support_ticket_close' | i18next }}</button>
            </div>
          }
        </div>
        <div class="ticket">
          <div class="sub">
            <div class="d-flex">
              <span>{{ "support_ticket_number" | i18next }} {{ ticket.number }}</span>
              <span class="ml-3">{{ "support_ticket_created" | i18next }} {{ ticket.createdAt | localized_datetime }}</span>
              @if (ticket.createdByName !== ' ') {
                <span class="ml-3">{{ "support_ticket_created_by" | i18next }} {{ ticket.createdByName }}</span>
              }
              <span class="ml-3">{{ "support_ticket_state" | i18next }} {{ ticket.stateTranslationString | i18next }}</span>
              @if (ticket.applianceId) {
                <span class="ml-3">
                  {{ "support_ticket_subscription" | i18next }}
                  @if (isLink) {
                    <a
                      [routerLink]="['/subscriptions', ticket.applianceId]"
                      class="btn-link ml-1"
                      name="appliance">
                      <span>[{{ ticket.applianceId }}]</span>
                      <span class="ml-1">{{ subscription.name }}</span>
                    </a>
                  } @else {
                    <span>[{{ ticket.applianceId }}]</span>
                  }
                </span>
              }
              @if (!!ticket.closedAt) {
                <span class="ml-3">{{ "support_ticket_closed" | i18next }} {{ ticket.closedAt | localized_datetime }}</span>
              }
            </div>
          </div>
          <div class="articles">
            @for (article of ticket.articles; track article) {
              <app-article-card [article]="article" [ticketId]="ticket.id"></app-article-card>
            }
          </div>
          @if (!isTicketClosed) {
            <div class="editor mt-3 mb-3">
              <app-article-editor [(message)]="articleMessage"></app-article-editor>
              <div class="d-flex bd-highlight mt-3 mb-3">
                <div class="mr-auto ticket">
                  @if (!isRequesting) {
                    <app-upload-attachments-form id="upload-form" [applianceId]="ticket.applianceId" (onFilesChanged)="onFilesChanged($event)" (onUpload)="onUpload($event)"></app-upload-attachments-form>
                  }
                </div>
                <div>
                  <button name="detail" class="btn btn-outline-primary" (click)="sendArticle()" [disabled]="isRequesting || !articleMessage || isUploading">{{'app_reply' | i18next}}</button>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    }
    @if (!isTicketView) {
      <app-close-ticket-warning [ticketNumber]="ticket.number" (confirm)="onCloseConfirm()" (back)="onCloseCancel()"></app-close-ticket-warning>
    }
  </div>
}
